import React from "react"

import { commonErr } from "../common/errors"
import { LoadingInlineSmall } from "../common/loading"
import { IcFavorite, IcFavoriteActive, IcHeart } from "./svg"
import { addFavoriteCar, removeFavoriteCar } from "../../model/car"

class FavoriteButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonState: 0, //0: unfavorite 1: adding favorite 2: added favorite
        }
    }

    componentDidMount() {
        if (this.props.car.fav === 1) {
            this.setState({
                buttonState: 2
            });
        }
   
    }

    componentDidUpdate(props) {
    
        if (props.car.fav !== this.props.car.fav) {
            this.setState({
                buttonState: this.props.car.fav === 1 ? 2 : 0
            })    
        }
    }
    
    addToFavorites = (e) => {
        e.preventDefault()

        if (!this.props.isLogged) {
            this.props.showLoginForm();
        } else {
            this.setState({
                buttonState: 1
            });
            addFavoriteCar(this.props.car.id, this.props.stype).then(resp => {
                if (resp.data.error >= commonErr.SUCCESS) {
                    this.setState({
                        buttonState: 2
                    });
                }
            });
        }
    }

    removeFromFavorites = (e) => {
        
        e.preventDefault()

        if (!this.props.isLogged) {
            this.props.showLoginForm();
        } else {
            this.setState({
                buttonState: 1
            });
            removeFavoriteCar(this.props.car.id, this.props.stype).then(resp => {
                if (resp.data.error >= commonErr.SUCCESS) {
                    this.setState({
                        buttonState: 0
                    });
                }
            });
        }
    }

    render() {
        const { icon } = this.props
        var content;
        var { buttonState}  = this.state;
        if(!icon) {
            if (buttonState === 2) {
                content = <div className="fav-item wrap-ic wrap-svg active" onClick={this.removeFromFavorites}>
                                <IcHeart />
                            </div>
            }  else {
                content = <div className="fav-item wrap-ic wrap-svg" onClick={this.addToFavorites}>
                                <IcHeart />
                            </div>
            }
        } else {
            if (buttonState === 2) {
                content = <div className="fav-item wrap-svg" name="favIcon"  onClick={(e) => this.removeFromFavorites(e)}>
                                <IcFavoriteActive />
                            </div>
            } else {
                content = <div className="fav-item wrap-svg" name="favIcon"  onClick={(e) => this.addToFavorites(e)}>
                            <IcFavorite />
                         </div>
            }
        }

        return content;
    }
}

export default FavoriteButton;